import PropTypes from 'prop-types';
import React from 'react';
import CurrencyChooser from 'views/ui/form_controls/session_currency_chooser';
import LanguageChooser from 'views/ui/form_controls/session_language_chooser';
import { loadLocales } from 'services/translation';
import './index.scss';

class PluginHeader extends React.PureComponent {
  static displayName = 'PluginHeader';

  static propTypes = {
    show_translate: PropTypes.bool,
    currency: PropTypes.string,
    supported_currencies: PropTypes.array,
    supported_languages: PropTypes.array,
  };

  static defaultProps = {
    show_translate: false,
    currency: 'usd',
    i18n: 'en-US',
    supported_languages: [],
    supported_currencies: ['usd'],
  };

  i18n = '';

  UNSAFE_componentWillMount() {
    this.i18n =
      this.props.i18n ||
      (this.props.tour && this.props.tour.i18n_locale) ||
      'en-US';
    loadLocales(this.i18n);
  }

  _renderGoogleTranslate = () => {
    let view = null;

    if (
      this.props.show_translate &&
      this.props.supported_languages.length === 0
    ) {
      view = (
        <div className="GoogleTranslate">
          <div
            id="google_translate_element"
            className="GoogleTranslate-element"
          />
        </div>
      );
    }
    return view;
  };

  _renderCurrencyChooser = (showCurrencyChooser) => {
    return showCurrencyChooser ? (
      <CurrencyChooser
        initialCurrency={this.props.currency}
        supportedCurrencies={this.props.supported_currencies}
        icon={<i className="icon af-triangle-down-2" />}
      />
    ) : (
      ''
    );
  };

  _renderPluginHeader = (showPluginHeader) => {
    return showPluginHeader ? (
      <div className="PluginHeader">
        {this._renderCurrencyChooser(this.props.show_currency)}

        <LanguageChooser
          initialLanguage={this.i18n}
          supportedLanguages={this.props.supported_languages}
          icon={<i className="icon af-triangle-down-2" />}
        />
        {this._renderGoogleTranslate()}
      </div>
    ) : (
      ''
    );
  };

  render() {
    return this._renderPluginHeader(this.props.show_header);
  }
}

export default PluginHeader;
